import { useId } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { buildDatePickerButtonRenderer } from '@interxfi/design-system/components/input/date-picker-input/activators/button/date-picker-button-activator';
import { DatePickerInput } from '@interxfi/design-system/components/input/date-picker-input/date-picker-input';
import { useDateAfterTodayDeterminer } from '@interxfi/design-system/components/input/date-picker-input/util';
import { PageTabRail } from '../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { type PortalTabbedNavigationTab, TabbedNavigationGroup } from '../../../../../../../../../components/router/router-tabbed-navigation';
import {
  RaglCustomerCashBalanceTable,
  type RaglCustomerCashBalanceTableHeaderProps,
} from '../../../../../../../../../features/clearing-ledger/customer-cash-balance/ragl-customer-cash-balance-table';
import { getPageHead } from '../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/customer-cash-balance/_customer-cash-balance/',
)({
  staticData: {
    tab: {
      group: TabbedNavigationGroup.ClearingOperationsCore,
      label: 'Customer Cash Balances',
      order: 4,
    },
  } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsCore>,
  head: () => getPageHead('Customer Cash Balances'),
  component: CustomerCashBalance,
});

const DatePickerActivatorRenderer = buildDatePickerButtonRenderer('en-US', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

function TableHeader({ asOf, filter, onAsOfChange }: RaglCustomerCashBalanceTableHeaderProps) {
  const id = useId();
  const dateAvailabilityDeterminer = useDateAfterTodayDeterminer();

  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          <DatePickerInput
            Activator={DatePickerActivatorRenderer}
            dateAvailabilityDeterminer={dateAvailabilityDeterminer}
            label="Select Date"
            name={`${id}-as-of-date`}
            onChange={(e) => onAsOfChange(e.target.value)}
            value={asOf}
          />
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsCore}
    />
  );
}

function CustomerCashBalance() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <RaglCustomerCashBalanceTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
